<script setup lang="ts">
// Default layout for all pages
// Includes the main header and footer components
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <!-- Header (sticky navigation) -->
    <LayoutHeader />

    <!-- Main content area -->
    <main class="flex-1">
      <slot ></slot>
    </main>

    <!-- Footer -->
    <LayoutFooter />
  </div>
</template>
